var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTwitter3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Component 26",
    clipPath: "url(#clip0_462_2872)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M14.5988 17.4261C10.9429 17.8163 7.27587 17.8163 3.61995 17.4261C2.16217 17.2705 1.01074 16.1191 0.855151 14.6612C0.46495 11.0052 0.46495 7.33837 0.855151 3.68245C1.01074 2.22467 2.16217 1.07324 3.61995 0.917651C7.27587 0.52745 10.9427 0.52745 14.5987 0.917651C16.0566 1.07324 17.208 2.22467 17.3636 3.68245C17.7538 7.33837 17.7538 11.0052 17.3636 14.6612C17.208 16.1191 16.0567 17.2705 14.5988 17.4261Z",
    fill: "url(#paint0_linear_462_2872)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M14.4082 5.88339C14.03 6.08123 13.4603 6.17265 13.2715 6.199C13.2699 6.18987 13.2684 6.18113 13.2668 6.17239C13.9088 5.77528 14.1054 5.02761 14.1054 5.02761C13.7077 5.25492 13.3573 5.38103 13.0933 5.45094C12.9449 5.49071 12.8238 5.51223 12.7367 5.52423C12.3365 5.11394 11.7778 4.85938 11.1594 4.85938C9.94265 4.85938 8.95606 5.8457 8.95606 7.06286C8.95606 7.10668 8.95724 7.15024 8.9601 7.19341C8.96597 7.29892 8.97941 7.4026 9.00014 7.50341C8.41119 7.49467 6.2853 7.31404 4.52365 5.2677C4.52365 5.2677 3.54267 6.97927 5.1919 8.14844C5.1919 8.14844 4.52365 8.12757 4.16892 7.87704C4.16892 7.87704 4.06459 9.52627 5.96408 10.0479C5.96408 10.0479 5.29623 10.2151 4.96198 10.0689C4.96198 10.0689 5.2961 11.4884 6.96606 11.593C6.96606 11.593 5.76833 12.6895 3.8125 12.5317C4.77444 13.1407 5.91492 13.4932 7.13769 13.4932C10.5758 13.4932 13.363 10.7061 13.363 7.26801C13.363 7.2251 13.3626 7.18219 13.3617 7.13929C13.3626 7.11386 13.363 7.08856 13.363 7.06286C13.363 7.045 13.3626 7.02713 13.3624 7.00926C13.998 6.58568 14.4082 5.88339 14.4082 5.88339Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_462_2872",
    x1: 6.23795,
    y1: 3.02835,
    x2: 10.5614,
    y2: 12.2786,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00C3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00B0ED"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_462_2872"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 17.0938,
    height: 17.0938,
    fill: "white",
    transform: "translate(0.5625 0.625)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter3);
export default __webpack_public_path__ + "static/media/Twitter3.fdb9c91617db69002809cfd26a7b48ee.svg";
export { ForwardRef as ReactComponent };